import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { isAuthorizedAdmin } from '../config/adminConfig';

const AdminContext = createContext();
export function useAdmin() { return useContext(AdminContext); }

export function AdminProvider({ children }) {
  const { currentUser, loading: authLoading, signIn, logout: authLogout, getToken } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setIsAdmin(currentUser ? isAuthorizedAdmin(currentUser) : false);
    setLoading(authLoading);
  }, [currentUser, authLoading]);

  // loginAdmin — gleiche Signatur wie alte Firebase-Version
  const loginAdmin = async (email, password) => {
    try {
      const user = await signIn(email, password);
      if (!isAuthorizedAdmin(user)) {
        await authLogout();
        return { success: false, error: 'Unauthorized access — Admin account required' };
      }
      return { success: true, user };
    } catch (err) {
      return {
        success: false,
        error: err.code === 'auth/invalid-credential'
          ? 'Invalid email or password. Please check your credentials.'
          : err.message,
      };
    }
  };

  // loginWithGoogle nicht mehr verfügbar — mappt auf loginAdmin mit Hinweis
  const loginWithGoogle = async () => {
    return { success: false, error: 'Google Sign-In nicht aktiv. Bitte Email/Passwort verwenden.' };
  };

  const logoutAdmin = async () => {
    await authLogout();
    return { success: true };
  };

  const value = {
    currentUser,
    isAdmin,
    loginAdmin,
    loginWithGoogle,
    logoutAdmin,
    loading,
    firebaseAvailable: false,
    getToken,
  };

  return (
    <AdminContext.Provider value={value}>
      {!loading && children}
    </AdminContext.Provider>
  );
}
